module.exports = __webpack_public_path__ + "img/icon-rearrow.b00f0733.svg";